import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { PainPointsSection } from './components/PainPointsSection';
import { ComparisonSection } from './components/ComparisonSection';
import { TransformationSection } from './components/TransformationSection';
import { KitContentsSection } from './components/KitContentsSection';
import { PreviewSection } from './components/PreviewSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { ForWhoSection } from './components/ForWhoSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { StickyCTABar } from './components/StickyCTABar';
import { HERO_MOCKUP, SITE_DESCRIPTION, SITE_TITLE, SITE_URL } from './data/site';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'fr';
    document.title = SITE_TITLE;
    setMeta('name', 'description', SITE_DESCRIPTION);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:locale', 'fr_FR');
    setMeta('property', 'og:site_name', 'MUSIQUE PRÊTE');
    setMeta('property', 'og:title', SITE_TITLE);
    setMeta('property', 'og:description', SITE_DESCRIPTION);
    setMeta('property', 'og:url', SITE_URL);
    setMeta('property', 'og:image', HERO_MOCKUP.src);
    setMeta('property', 'og:image:width', String(HERO_MOCKUP.width));
    setMeta('property', 'og:image:height', String(HERO_MOCKUP.height));
    setMeta('property', 'og:image:alt', HERO_MOCKUP.alt);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', SITE_TITLE);
    setMeta('name', 'twitter:description', SITE_DESCRIPTION);
    setMeta('name', 'twitter:image', HERO_MOCKUP.src);
    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = SITE_URL;
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3gm64zskiyz4x">
      <div className="min-h-screen w-full bg-white font-sans text-slate-800 selection:bg-brand-gold/40" data-id="element-1" data-mp="3gj1s86szuv2n">
        <AnnouncementBar data-id="element-2" data-mp="3qb7j1d7if6g9" />
        <main data-id="element-3" data-mp="3qbpl4qgusew3">
          <HeroSection data-id="element-4" data-mp="3qc95edtz7fda" />
          <StatsBar data-id="element-5" data-mp="3qcimtd0yge7d" />
          <PainPointsSection data-id="element-6" data-mp="3qd0t72hc08t0" />
          <ComparisonSection data-id="element-7" data-mp="3ljxukfxp695y" />
          <TransformationSection data-id="element-8" data-mp="3ljpkswwvfjyz" />
          <KitContentsSection data-id="element-9" data-mp="3limqef0cazeb" />
          <PreviewSection data-id="element-10" data-mp="2xud8ho68yvsg" />
          <InstantAccessSection data-id="element-11" data-mp="2xtlolam0imi0" />
          <ForWhoSection data-id="element-12" data-mp="2xsk30c7dehm1" />
          <BonusesSection data-id="element-13" data-mp="2sw243syq1dhm" />
          <PricingSection data-id="element-14" data-mp="2suquvdmibdj4" />
          <GuaranteeSection data-id="element-15" data-mp="2svjy44m9bkwi" />
          <FAQSection data-id="element-16" data-mp="18drfvlydcx92" />
          <FinalCTASection data-id="element-17" data-mp="18dhq9zh8ks3w" />
        </main>
        <Footer data-id="element-18" data-mp="18cgfzx81o9n8" />
        <StickyCTABar data-id="element-19" data-mp="18by9m7ro4f1l" />
      </div>
    </MotionConfig>;
}
function setMeta(attribute: 'name' | 'property', key: string, content: string) {
  let meta = document.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attribute, key);
    document.head.appendChild(meta);
  }
  meta.content = content;
}